import React, { useState, useEffect } from 'react';
import { Modal, Progress } from 'antd';
import http from '../../../Http';
import { useTranslation } from 'react-i18next';
import { isBurnCancelled, v2BurnCancelLabel } from './burnProgress';

const BurningMonitor = ({ visible, type_, burningID, dataLength, onCancel }) => {
    const { t } = useTranslation();
    const [progress, setProgress] = useState(0);
    const [cancelCode, setCancelCode] = useState(null);

    useEffect(() => {
        let intervalId;

        const fetchProgress = async () => {
            try {
                const resp = await http.postJSON('integrated-inverter-v2/burning-progress/request', {
                    Type: type_,
                    BurnID: burningID,
                }
                ).then(async (r) => {
                    return await r.json();
                }).catch((e) => {
                    console.log("[BurningManagement]", e);
                    return null;
                });
    
                if (resp == null || resp.code !== 200) {
                    return;
                }
                const currentProgress = resp.data.Progress;
                if (isBurnCancelled(currentProgress)) {
                    setCancelCode(parseInt(currentProgress, 10));
                    if (intervalId) {
                        clearInterval(intervalId);
                    }
                    return;
                }
                setProgress((currentProgress / dataLength) * 100);
            } catch (error) {
                console.error(t('Error fetching progress:'), error);
            }
        };

        if (visible) {
            setProgress(0);
            setCancelCode(null);
            fetchProgress();
            intervalId = setInterval(fetchProgress, 3000);
        }

        return () => {
            if (intervalId) {
                clearInterval(intervalId);
            }
        };
    }, [visible, dataLength, burningID, type_, t]);

    const handleClose = () => {
        onCancel(cancelCode != null ? cancelCode : Math.round(progress));
    };

    return (
        <Modal
            title={t("Burning Progress")}
            visible={visible}
            onCancel={handleClose}
            footer={null}
        >
            {cancelCode != null ? (
                <div style={{ color: '#ff4d4f' }}>
                    {v2BurnCancelLabel(cancelCode, t)}
                </div>
            ) : (
                <Progress percent={Math.round(progress)} status="active" />
            )}
        </Modal>
    );
};

export default BurningMonitor;
